import React from 'react';
import { useFreemiumGatingContext } from 'contexts/FreemiumGatingContext/FreemiumGatingContext';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import RemainingCredits from './RemainingCredits';
import { StartFreeTrial } from './StartFreeTrial';

export const CreditsOrUpsell = ({ onClick }: { onClick?: () => void }) => {
    const { isAppGated } = useFreemiumGatingContext();
    const { isDAWPlugin } = useExecutionEnvironmentContext();

    const target = isDAWPlugin ? '_blank' : '_self';

    return (
        <>
            {isAppGated && <StartFreeTrial onClick={onClick} />}
            {!isAppGated && (
                <RemainingCredits target={target} onClick={onClick} />
            )}
        </>
    );
};
